(ns frontend.components.inputs.allocation-split
  (:require
   [frontend.components.inputs.footprint :refer [editor viewer display-string]]
   [common.localization :as loc]
   [reagent.core :as r]
   [frontend.utils :as fu]
   [common.util :as cu]
   [cljs.reader :as edn]
   [frontend.bootstrap.components :as rbs]
   [reagent.dom :as rd]
   [ui.components.button.view :as button]))

(def row-keys [:revenue :ebitda])

(defn default-row
  [years]
  (reduce (fn [acc year]
            (assoc acc year nil))
          {}
          years))

(defn default-value
  []
  [])

(defn default-edit-value
  []
  [["" 100.0]])

(defn render-edit-mode
  [dom-atom clear-state! args]
  (let [{:keys [:value :placeholder :class-name
                on-change! on-key-down! unique-id]}
        args
        edit-value (or (:temp-value @dom-atom)
                       (when (coll? value) value))
        render-value (vec (or edit-value
                              (when (coll? value) value)
                              (default-edit-value)))
        sum (->> render-value
                 (map (fn [row]
                        (when (and (coll? row)
                                   (= 2 (count row))
                                   (number? (second row)))
                          (second row))))
                 (remove nil?)
                 (apply +))]
    [:div.allocation-split-container
     [:table.allocation-split
      [:thead
       [:tr.allocation-split-header-row.d-none
        [:th.allocation-split-cell.allocation-split-cell--header
         (loc/tr :allocation.split/target)]
        [:th.allocation-split-cell.allocation-split-cell--header
         (loc/tr :allocation.split/split)]]]
      [:tbody
       (->> render-value
            (map-indexed
             (fn [idx row]
               (let [label (first row)
                     percentage (second row)]
                 (when (and row
                            (coll? row)
                            (= (count row) 2))
                   ^{:key (str "allocation-split-" idx)}
                   [:tr
                    [:td
                     [:input
                      {:placeholder (or placeholder "")
                       :type        "text"
                       :value       (or label)
                       :on-change   (fn [e]
                                      (let [changed-text (-> e
                                                             .-target
                                                             .-value)]
                                        (swap! dom-atom assoc :temp-value (assoc render-value idx [changed-text percentage]))))
                       :on-blur     (fn [e]
                                      (let [new-value (if (= label "")
                                                        (assoc render-value idx ["" percentage])
                                                        render-value)]
                                        (swap! dom-atom assoc :temp-value new-value)))
                       :on-key-down on-key-down!}]]
                    [:td
                     [:input
                      {:placeholder (or placeholder "")
                       :type        "text"
                       :value       (let [draw-value percentage
                                          min-decimal-count (if (nil? draw-value)
                                                              -1
                                                              (or (get-in @dom-atom [:decimals idx :decimal-count])
                                                                  -1))
                                          edit-negative? (get-in @dom-atom [:decimals idx :negative?])]
                                      (or (when draw-value
                                            (if (= draw-value "")
                                              (when edit-negative? "-")
                                              (fu/format-with-separators draw-value min-decimal-count edit-negative?)))
                                          ""))
                       :on-change   (fn [e]
                                      (let [input (-> e
                                                      .-target
                                                      .-value)
                                            float-value (fu/parse-float-info input "")
                                            new-cell-value (:float-value float-value)
                                            new-value (assoc render-value idx [label new-cell-value])]
                                        (swap! dom-atom assoc :temp-value new-value)
                                        (swap! dom-atom assoc-in
                                          [:decimals idx]
                                          {:decimal-count (or (:decimal-count float-value) -1)
                                           :negative?     (or (:negative? float-value) false)})
                                        (when on-change!
                                          (on-change! e new-value))))
                       :on-blur     (fn [e]
                                      (let [new-value (if (= percentage "")
                                                        (assoc render-value idx [label 0])
                                                        render-value)]
                                        (swap! dom-atom assoc :temp-value new-value)))
                       :on-key-down on-key-down!}]]
                    [:td
                     [:i.fal.fa-trash-alt
                      {:on-click (fn [e]
                                   (swap! dom-atom assoc
                                     :temp-value
                                     (cond
                                       (= idx 0)
                                       (drop 1 render-value)
                                       (= idx (count render-value))
                                       (subvec render-value
                                               0
                                               (-> render-value
                                                   (count)
                                                   (dec)))
                                       :else
                                       (concat (subvec render-value 0 idx)
                                               (subvec render-value (inc idx)))))
                                 )}]]]))))
            (remove nil?)
            (doall))]
      [:tfoot
       [:tr
        [:td.allocation-split-cell.allocation-split-cell--footer]
        [:td.allocation-split-cell.allocation-split-cell--footer
         sum
         [:span
          (let [roundedpercent (int (* 100 (.toFixed sum 2)))
                hundredpercent 10000]
            (when-not (= roundedpercent hundredpercent)
              [button/secondary-open
               {:tooltip (loc/tr :allocation-split-sum-should-be-100)}
               [:i.fas.fa-exclamation-triangle.salmon.ml-2]]))]]
        [:td]]]]
     [:a
      {:href     "#"
       :on-click (fn [e]
                   (swap! dom-atom assoc :temp-value (vec (concat render-value [["" 0.0]]))))}
      (loc/tr :add-new)]]))

(defn render-read-mode
  [dom-atom args]
  (let [{:keys [:value :placeholder :class-name
                has-focus? on-focus! on-blur!
                :on-change! :on-key-down! :disabled?]}
        args
        edit-value (or (:temp-value @dom-atom)
                       (when (coll? value) value))
        render-value (vec (or edit-value
                              (when (coll? value) value)
                              (default-value)))
        total (some->> edit-value
                       (map second)
                       (apply +))]
    [:div.allocation-split-container
     (when (and render-value
                (> (count render-value) 0))
       [:ul.allocation-split-read-mode
        (->> render-value
             (map-indexed
              (fn [idx row]
                (let [label (first row)
                      percentage (second row)]
                  (when (and row
                             (coll? row)
                             (= (count row) 2))
                    ^{:key (str "allocation-split-" idx)}
                    [:li
                     [:label.allocation-split-read-label
                      label]
                     [:span.allocation-split-read-value
                      (str percentage "%")]
                     (when (and (= idx
                                   (->> render-value
                                        (count)
                                        (dec)))
                                (not= 10000 (int (* 100 total))))

                       [button/secondary-open
                        {:tootip (loc/tr :allocation-split-sum-should-be-100)}
                        [:i.fas.fa-exclamation-triangle.salmon.ml-2]]
                       )]))))
             (doall))])
     (when (or (not value)
               (not (coll? value))
               (empty? value))
       [:a.new-value
        {:href     "#"
         :on-click (fn [e]
                     (on-focus!)
                     (let [new-value (:temp-value (swap! dom-atom assoc :temp-value (vec (concat render-value [["" 0.0]]))))]
                       (on-change! e new-value)))}
        (if (empty? render-value)
          (loc/tr :add)
          (loc/tr :add-new))])]))

(defmethod editor :editor.type/allocation-split
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        {:keys [set-focusable-element! set-cancel-edit! set-save! on-change!
                on-focus! on-blur!]}
        args
        initial-value (:value args)
        clear-state! (fn []
                       (swap! dom-atom dissoc
                         :temp-value
                         :decimals))]
    (r/create-class
     {:display-name           "Allocation split"
      :component-did-mount    (fn [args]
                                (let []
                                  (swap! dom-atom assoc :initial-value initial-value)
                                  (when set-focusable-element!
                                    (set-focusable-element! (fn [e]
                                                              (on-focus!)
                                                              (on-change! e (concat initial-value [["" 0]])))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [e]
                                                        (swap! dom-atom dissoc :temp-value :edit-mode?)
                                                        (on-change! e initial-value)
                                                        (on-blur! e initial-value clear-state!)))) ;; save complete -> reset temp state
                                  (when (fn? set-save!)
                                    (set-save! (fn [e]
                                                 (when (fn? on-blur!)
                                                   (on-blur! e (:temp-value @dom-atom) clear-state!)))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (if (:has-focus? args)
                                  (render-edit-mode dom-atom clear-state! args)
                                  (render-read-mode dom-atom args)))})))

(defmethod display-string :editor.type/allocation-split
  [args]
  (let [value (:value args)
        arr (cond (string? value) (edn/read-string value)
                  (coll? value) value
                  :else value)]
    (cu/tab-separated-string arr)))

(defn allocation-split-table
  [args]
  (let [data (:value args)
        header [(loc/tr :allocation.split/target) (loc/tr :allocation.split/split)]]
    [:div.preview.preview-allocation-split
     [:table.allocation-split
      [:thead
       [:tr.allocation-split-header-row.d-none
        (doall
         (for [h header]
           ^{:key (str h)}
           [:th.allocation-split-cell.allocation-split-cell--header
            h]))]]
      [:tbody
       (->> data
            (map-indexed (fn [idx [target split]]
                           ^{:key (str "read-only-allocation-split-" idx)}
                           [:tr.allocation-split-row
                            [:td.allocation-split-cell
                             target]
                            [:td.allocation-split-cell
                             split]]))
            (doall))]]]))

(defmethod viewer :editor.type/allocation-split
  [args]
  (r/create-class
   {:display-name   "allocation-split/viewer"
    :reagent-render (fn [args]
                      [allocation-split-table args])}))
